// ABOUTME: RTK Query slice for invoice product categories (CRUD + select/list endpoints)
// ABOUTME: Talks to the /api/invoiceproductcategories backend routes
import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const INVOICEPRODUCTCATEGORY_BASE = "/invoiceproductcategories";
const buildUrl = (endpoint) => INVOICEPRODUCTCATEGORY_BASE + endpoint;
const API_TAG = 'InvoiceProductCategories';

const invoiceProductCategorySlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        getInvoiceProductCategoryList: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: API_TAG }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getInvoiceProductCategoryList', API_TAG)
        }),
        getInvoiceProductCategorySelect: builder.query({
            query: () => ({
                url: buildUrl(`/select`),
                method: 'GET',
            }),
            providesTags: () => [{ type: API_TAG }]
        }),
        getInvoiceProductCategory: builder.query({
            query: (id) => ({
                url: buildUrl(`/${id}`),
                method: 'GET',
            }),
            providesTags: (result, error, arg) => [{ type: `${API_TAG}Single`, id: arg }]
        }),
        addInvoiceProductCategory: builder.mutation({
            query: invoiceProductCategoryInfo => ({
                url: buildUrl(`/new`),
                method: 'POST',
                body: invoiceProductCategoryInfo,
            }),
            invalidatesTags: (result, error, arg) => [{type: API_TAG}],
        }),
        updateInvoiceProductCategory: builder.mutation({
            query: invoiceProductCategoryInfo => ({
                url: buildUrl(`/${invoiceProductCategoryInfo.id}`),
                method: 'PUT',
                body: invoiceProductCategoryInfo,
            }),
            invalidatesTags: (result, error, arg) => [{type: API_TAG }, { type: `${API_TAG}Single`, id: arg.id }],
        }),
        deleteInvoiceProductCategory: builder.mutation({
            query: (id) => ({
                url: buildUrl(`/${id}`),
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, arg) => [{type: API_TAG }, { type: `${API_TAG}Single`, id: arg.id }],
        }),
    })
});

export const {
    useGetInvoiceProductCategoryListQuery,
    useGetInvoiceProductCategorySelectQuery,
    useGetInvoiceProductCategoryQuery,
    useAddInvoiceProductCategoryMutation,
    useUpdateInvoiceProductCategoryMutation,
    useDeleteInvoiceProductCategoryMutation,
  } = invoiceProductCategorySlice;
